/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import {
    HStack,
    IconButton,
    Input,
    InputGroup,
    InputLeftElement,
    InputRightElement,
} from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { faCalendar, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FaIcon } from '../fa-icon';

function DateInputRefFunction(
    {
        size = 'md',
        inputGroupProps = {},
        isPopoverOpen,
        selectedDate,
        onClear,
        noDateSelectedText,
        allowClear,
        placeholder: inputPlaceholder,
        onCalendarClick,
        onInputValueChange,
        inputValue,
        ...inputProps
    }: {
        size: React.ComponentProps<typeof InputGroup>['size'];
        inputGroupProps?: Omit<React.ComponentProps<typeof InputGroup>, 'size'>;
        isPopoverOpen: boolean;
        selectedDate?: Date | null;
        noDateSelectedText: string;
        onClear: () => void;
        allowClear: boolean;
        inputValue: string;
        onCalendarClick: () => void;
        onInputValueChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    } & Omit<React.ComponentProps<typeof Input>, 'ref'>,
    ref: React.ForwardedRef<HTMLInputElement>
) {
    const placeholder = useMemo<string | undefined>(() => {
        if (selectedDate === null && noDateSelectedText !== '') {
            return noDateSelectedText;
        }

        return inputPlaceholder;
    }, [inputPlaceholder, noDateSelectedText, selectedDate]);

    return (
        <InputGroup size={size} cursor="pointer" {...inputGroupProps}>
            <InputLeftElement
                color="gray.500"
                onClick={onCalendarClick}
                _hover={{
                    color: 'secondary.500',
                    bgColor: 'secondary.25',
                }}
                _focusVisible={{
                    color: 'secondary.500',
                    bgColor: 'secondary.25',
                }}
                data-focus-visible={isPopoverOpen || undefined}
                transition="all 0.2s"
                rounded="full"
                cursor="pointer"
                w={8}
                h={8}
                mt={1}
                ml={1}
            >
                <FaIcon icon={faCalendar} />
            </InputLeftElement>
            <Input
                ref={ref}
                data-focus-visible={isPopoverOpen || undefined}
                value={inputValue}
                onChange={onInputValueChange}
                placeholder={placeholder}
                {...inputProps}
            />
            <InputRightElement as={HStack} pr={3} justifyContent="flex-end" w="20" color="black" pointerEvents="none" gap={0}>
                {allowClear && typeof inputValue === 'string' && inputValue.trim() !== '' && (
                    <IconButton
                        colorScheme="blackAlpha"
                        size="xs"
                        pointerEvents="all"
                        variant="ghost"
                        aria-label="clear selection"
                        icon={<FaIcon icon={faTimes} />}
                        onClick={onClear}
                    />
                )}
            </InputRightElement>
        </InputGroup>
    );
}

export const DateInput = React.forwardRef(DateInputRefFunction);
